import { render, staticRenderFns } from "./workflow-access-table-status.vue?vue&type=template&id=52f7e916"
import script from "./workflow-access-table-status.vue?vue&type=script&lang=js"
export * from "./workflow-access-table-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports